
import Vue from 'vue';
import axios from 'axios';

interface FaqItem {
  question: string;
  answer: string;
}

export default Vue.extend({
  name: 'FAQ',
  data() {
      return {
          currentQuestion: -1,
          isLoading: true,
          hasError: false,
          faq: [] as FaqItem[],
      };
  },
  created() {
    axios
      .get('https://rckik-katowice.pl/wp-json/wp/v2/pages/6806')
      .then((response) => {
        this.faq = (response.data && response.data.acf && response.data.acf.items) || [];
      })
      .catch(() => {
        this.hasError = true;
      })
      .then(() => {
        this.isLoading = false;
      });
  },
  methods: {
    showAnswer(id: number) {
      this.currentQuestion = id === this.currentQuestion ? -1 : id;
    },
  },
});
